import React from 'react';
import {withRouter} from 'react-router';
import {Link} from 'react-router-dom';
import {Breadcrumb} from 'antd';

import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';


/**
 * 生成页面面包屑导航
 * 根据匹配到路由路径生成面包屑导航
 */
@withRouter
class MyBreadcrumb extends React.Component {
    render() {

        let breadcrumb_item = [];

        let normalStyle = {
            fontSize: '15px',
        }

        let lastStyle = {
            fontSize: '16px',
            fontWeight: '700',
            color: '#1890ff',
        }

        let count = breadcrumb_store.itemList.length;
        for (let i = 0; i < count; i++) {
            let item = breadcrumb_store.itemList[i];
            let itemStyle = normalStyle;
            if (i + 1 == count) {
                itemStyle = lastStyle;
            }
            breadcrumb_item.push(
                (
                    <Breadcrumb.Item key={item.path}>
                        <Link
                            style={itemStyle}
                            to={item.path}
                            onClick={() => {
                                breadcrumb_store.popItem(item);
                            }}
                        >{item.name}</Link>
                    </Breadcrumb.Item>
                )
            );
        }

        return (
            <Breadcrumb
                style={{float: 'left'}}
            >
                {
                    breadcrumb_item
                }
            </Breadcrumb>
        )
    }
}

export default MyBreadcrumb;



// WEBPACK FOOTER //
// ./src/components/MyBreadcrumb/MyBreadcrumb.jsx